import React from "react";
import LfReset from "glossy/components/lf-reset";
import styled from "styled-components";
import { FontSize, FontWeight, Spacing, message } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import Icon from "@ui-kit/icon";
import { tr } from "@radarly/i18n";

interface IProps {
  locale: Locale;
  url: string;
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  gap: ${Spacing.Large};
  color: ${(p) => message(p, "error")};
`;

const Title = styled.h1`
  font-weight: ${FontWeight.Bold};
  font-size: ${FontSize.ExtraLarge};
`;

const RadarlyErrorBoundaryPage = ({ locale, url }: IProps) => (
  <Root>
    <LfReset />
    <Icon glyph="tone-negative" size={72} />
    <Title>{tr(locale, "INSIGHT-PAGES::ERROR-GLOBAL")}</Title>
    <Button
      text={tr(locale, "INSIGHT-PAGES::ERROR-REDIRECT")}
      onClick={() => window.location.assign(url)}
    />
  </Root>
);

export default RadarlyErrorBoundaryPage;
